export class EventUtils {

    /**
     * Gets the Event Path of the Event.
     * This is necessary because not all browsers provide the path attribute in their events.
     * Code taken and adapted from https://stackoverflow.com/a/46093727/7167819
     * @param evt
     */
    static getEventPath(evt): any {
        const path = (evt.composedPath && evt.composedPath()) || evt.path;
        const target = evt.target;

        if (path != null) {
            // Safari doesn't include Window, but it should.
            return (path.indexOf(window) < 0) ? path.concat(window) : path;
        }

        if (target === window) {
            return [window];
        }

        function getParents(node, memo?): any {
            memo = memo || [];
            const parentNode = node.parentNode;

            if (!parentNode) {
                return memo;
            }

            return getParents(parentNode, memo.concat(parentNode));
        }

        return [target].concat(getParents(target), window);
    }
}
